// =============================================================================
// state
// =============================================================================
const state = {
  carts: [],
  total_price: [],
  send_address: {},
  send_type: 1,
  new_address: {},
  history_id: -1,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  carts: state => state.carts,
  total_price: state => state.total_price,
  send_address: state => state.send_address,
  send_type: state => state.send_type,
  new_address: state => state.new_address,
  history_id: state => state.history_id,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_item (state, value) {
    state.carts.push(value);
  },
  del_item (state, value) {
    state.carts.splice(value, 1);
  },
  set_price (state, value) {
    state.total_price = value;
  },
  set_address (state, value) {
    state.send_address = value;
  },
  set_new_addreess (state, value) {
    state.new_address = value;
  },
  set_send_type (state, value) {
    state.send_type = value;
  },
  set_history_id (state, value) {
    state.history_id = value;
  },
  reset (state) {
    state.carts = [];
    state.total_price = [];
    state.send_address = {};
    state.new_address = {};
    state.send_type = 1;
    state.history_id = -1;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
